import PaintLicitationsWorkspace from '../../placeholders/PaintLicitationsWorkspace';

export default PaintLicitationsWorkspace;
